import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-mevo',
  template: `
    <footer class="footer"></footer>
  `,
  styles: [
    `
      .footer {
        background: #ffb6bf;
        position: absolute;
        bottom: 0;
        width: 100%;
        display: flex;
        height: 50px;
        z-index: 999;
      }
    `
  ]
})
export class FooterMevoComponent {}
